<div class="content-wrapper">
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Create New Skill</h4>
          <form class="forms-sample" #ngNewSkillForm="ngForm" name="form"
            (ngSubmit)="ngNewSkillForm.form.valid && onSubmit()" novalidate>

            <!-- Name -->
            <div class="form-group">
              <label for="name">Skill Name</label>
              <input type="text" class="form-control" id="name" placeholder="ex: Engineer" name="name"
                [(ngModel)]="name" required>
            </div>

            <!-- Description  -->
            <div class="form-group">
              <label for="description">Description</label>
              <input type="text" class="form-control" id="description"
                placeholder="Short description of the stated skill " name="description" [(ngModel)]="description"
                required>
            </div>

            <button type="submit" class="btn btn-primary mr-2">Submit</button>
            <button class="btn btn-light">Cancel</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>